import "../../styles/newRegister.css";
import dashboardImg from "../../assets/img/Dashboard.png";
import {
  Button,
  Card,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";
// import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  FormControl,
  IconButton,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
// import Logo from "../../assets/img/logo.png";
import Welcome from "../../assets/img/welcome.png";
import SnackUI from "../../common/SnackUI";
import { loginUserAction } from "../../redux/toolkit/auth/loginUser";
import Style from "../../styles/login.module.scss";
import LoadingUI from "../../common/LoadingUI";
import Visibility from "../../assets/img/eye-closed.png";
import VisibilityOff from "../../assets/img/eye.png";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { app } from "../../services/fribase";
import Logo from "../../assets/img/real_logo.svg";
import RealLogo from "../../assets/newIcons/RealLogo";

const NewLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [snack, setSnack] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const loginSelector = useSelector((state) => state.loginUser);
  const { message, status, loading } = loginSelector;
  const handleSubmitLogin = async (e) => {
    e.preventDefault();
    
    const loginData = await dispatch(loginUserAction({ email, password }));
    if (loginData?.payload?.status == 200) {
      localStorage.setItem("auth_token", loginData?.payload.token);
      
      navigate("/");
      window.location.reload();
    }
    setSnack(true);
  };
  return (
    <>
      <div className="container">
        <div className="header">
          <div className="left-header">
          <RealLogo/>
          </div>
          <div className="right-header">
            <p>
              Don’t have an account ? <button onClick={() => navigate("/register")}>Register</button>
            </p>
          </div>
        </div>

        <div className="form-image-container">
          <div className="form-container">
            <div className="form-header">
              <p className="p1">welcome</p>
              <p className="p3">Login to your dashboard</p>
              <p className="p2">  </p>
            </div>

            <div className="form">
              <div className="form-fields">
                <form onSubmit={handleSubmitLogin} className="spacey4">
                  <div className="field-wrap">
                    <label htmlFor="email">Email</label>
                    <input
                      type="email"
                      name="email"
                      placeholder="Enter your work email address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>

                  <div className="field-wrap">
                    <label htmlFor="mobile">PassWord</label>
                    <div
                      style={{
                        width: "100%",
                        position: "relative",
                        display: "inline-block",
                      }}
                    >
                      <input
                        type={showPassword ? "text" : "password"}
                        placeholder="Please Enter Password"
                        style={{ width: "100%" }}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                      <span
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "10px",
                          cursor: "pointer",
                        }}
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? (
                          <img src={VisibilityOff} width="23px" />
                        ) : (
                          <img src={Visibility} width="23px" />
                        )}
                      </span>
                    </div>
                  </div>

                  <div className="forgot-password">
                    <span onClick={() => navigate('/forgetpassword')}>Forgot Password ?</span>
                  </div>

                  <button
                    type="submit"
                    className="form-button"
                    //   className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition"
                    disabled={!(email && password)}

                     style={{
                      backgroundColor:
                       email && password
                          ? "#000"
                          : "#e0e0e0",
                    }}
                  > 
                    Login
                  </button>
                </form>
              </div>

              {/* <div className="form-button">
                <button>Register</button>
              </div> */}
            </div>
          </div>

          <div className="img-container">
            <img src={dashboardImg} alt="" />
          </div>
        </div>

        <div className="footer">
          <p>2025 Real Opinion | All Rights Reserved</p>
        </div>
      </div>

            {snack && <SnackUI state={snack} setState={setSnack} status={status} message={message} />}
      
    </>
  );
};

export default NewLogin;
